import { Response } from 'kts-scaffold-framework/server';
import { Agent, Request } from 'kts-scaffold-framework/server';
import { reducers, MyStore, Verification } from 'kts-platform-frame/redux';
import { serverDomain, serverPlatformDomain } from 'kts-platform-frame/entry/configUtils';
import message from 'kts-scaffold-framework/component/Message';
import { history } from 'kts-platform-frame/routes';
import service, { Tools } from 'kts-platform-frame/service';
import { Fns } from 'grey-group-function';

export default abstract class ApiBasic<O = any, D = any> {

    /** 请求列表 */
    public static readonly requestList = [];

    /** 错误信息列表 */
    public static readonly messageErrorList = [];

    /* 构造函数 */
    constructor() {
        this.api = this.api.bind(this);
        this.callAjax = this.callAjax.bind(this);
        this.callScaner = this.callScaner.bind(this);
        this.callFile = this.callFile.bind(this);
        this.call = this.call.bind(this);
    }

    /** 向服务器发送请求(callAjax) */
    public async callAjax(request: Request, mock: boolean = false): Promise<any> {
        // const { user } = MyStore.instance.getState();

        // if (user.cToken) {
        //     request.options.Authorization = user.cToken;
        // }

        // if (!request.options['x-kxl-app-key']) {
        //     request.options['x-kxl-app-key'] = this.inquiryApp(window.location.pathname);
        // }

        return await this.call(request, serverDomain(), mock);
    }

    /** 向服务器发送请求(平台) */
    public async callPlatform(request: Request, aToken?: string, mock: boolean = false): Promise<any> {
        const { user } = MyStore.instance.getState();
        request.options.Authorization = aToken || user.aToken || user.cToken;
        return await this.call(request, serverPlatformDomain(), mock);
    }

    /** 调用扫描仪 */
    public async callScaner(request: Request, mock: boolean = false): Promise<any> {
        return await Agent.instance.call(request, "http://localhost:8088", mock);
    }

    /** 上传文件 */
    public async callFile(request: Request, file: any): Promise<any> {
        const { user } = MyStore.instance.getState();
        MyStore.instance.dispatch(reducers.system.ActionTypes.addLoading, request.uri); // 添加loading
        request.options.Authorization = user.cToken;
        const res = await Agent.instance.file(request, file, this.envDomain(request.uri) || serverDomain());
        MyStore.instance.dispatch(reducers.system.ActionTypes.removeLoading, request.uri); // 删除loading
        return this.verificationResponse(request, res);
    }

    /** 打开新窗口 */
    public openWin(request: Request) {
        const domain = this.envDomain(request.uri) || serverDomain();
        window.open(domain + request.uri);
    }

    /**
     * 执行api
     * @param option api 入参
     */
    public run = async (target: any, option: O = {} as O): Promise<Response<D>> => {
        Verification.instance.stop();
        for (let i = 0; i < ApiBasic.requestList.length; i++) {
            const { self_target, self } = ApiBasic.requestList[i];
            if (self_target === target && this === self) {
                Verification.instance.start();
                return new Response('重复请求');
            }
        }

        if (target) {
            ApiBasic.requestList.push({
                self_target: target,
                self: this
            });
        }

        const api = await this.api(option);

        for (let i = 0; i < ApiBasic.requestList.length; i++) {
            const { self_target, self } = ApiBasic.requestList[i];
            if (self_target === target && this === self) {
                ApiBasic.requestList.splice(i, 1);
            }
        }
        Verification.instance.start();
        return api;
    }

    /** 
     * 抽象方法（子类api逻辑的实现入口） 
     * @param option api 入参
     */
    protected async api(option: O): Promise<Response<D>> {
        throw '请重写api方法';
    }

    /** 向服务器发送请求 */
    protected async call(request: Request, domain: string, mock: boolean = false): Promise<any> {

        const NO_MESSAGE_RES: Fns = [Tools.removeLoading, Tools.repeatCallEnd, Tools.loginInvalid, Tools.extractData];
        const MESSAGE_RES: Fns = [Tools.removeLoading, Tools.repeatCallEnd, Tools.verificationResponse, Tools.loginInvalid, Tools.extractData];

        let req = service.create(request.type as any, request.uri, request.params, domain);
        let res;

        req.set(request.options);
        if (request.isMessage) {
            res = await req.resFs(MESSAGE_RES).end(null);
        } else {
            res = await req.resFs(NO_MESSAGE_RES).end(null);
        }

        return { er: res.err, res: res.res };
    }

    /** 发送消息 */
    private messageError(request: Request, text: string) {
        // 是否需要发送消息
        if (!request.isMessage) {
            return;
        }

        // 消息是否存在
        if (ApiBasic.messageErrorList.indexOf(text) === 0) {
            return;
        }

        // 发送消息
        ApiBasic.messageErrorList.unshift(text);
        message.error(text);

        // 一秒后删除记录
        setTimeout(() => {
            const t = ApiBasic.messageErrorList.indexOf(text);
            ApiBasic.messageErrorList.splice(t, 1);
        }, 2000);
    }

    /** 请求头（环境参数） */
    private envDomain = (uri: string) => {
        const { env } = MyStore.instance.getState();
        if (env.DOMAIN_MAP) {
            if (env.DOMAIN_MAP[uri]) {
                return env.DOMAIN_MAP[uri];
            } else {
                for (let key in env.DOMAIN_MAP) {
                    if (key.substr(-1, 1) === '*' && uri.indexOf(key.slice(0, -1)) === 0) {
                        return env.DOMAIN_MAP[key];
                    }
                }
            }
        }
    }

    /** 验证服务器数据是否错误 */
    private verificationResponse(request: Request, res: Response<any>) {
        // 通信错误
        try {
            if (res.er) {
                this.messageError(request, '服务器异常');
                return res;
            }

            // 通信错误
            if (res.res.ok === false) {
                this.messageError(request, '系统异常');
                return new Response(res.res);
            }

            // 业务失败
            if (res.res.body.ok === false) {
                if (res.res.body.status && (res.res.body.status.description || res.res.body.status.message)) {
                    if (res.res.body.status.returnCode === '02001') {
                        MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, { gToken: null, cToken: null }); 
                        if (window.location.pathname !== '/login') {
                            MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, { gToken: null, cToken: null });
                            if (window.location.href) {
                                history.push(`/login?redirectURL=${escape(window.location.pathname + window.location.search)}`);
                            } else {
                                history.push(`/login`);
                            }
                        }   
                    }
                    this.messageError(request, res.res.body.status.description || res.res.body.status.message);
                } else {
                    this.messageError(request, '系统错误');
                }
                return new Response(res.res);
            }
        } catch (er) {
            this.messageError(request, '网络不稳定，请稍后');
            return new Response(res.res);
        }

        return new Response(null, res.res.body.body);
    }

    /** 通过 pathname 查询app key */
    private inquiryApp = (pathname: string): string => {
        let key: string = null;
        const appMap = MyStore.instance.getState().config.appList.map;
        appMap.forEach((e, k) => {
            if (pathname.indexOf(e.URL) === 0) {
                key = k;
            }
        });

        if (key === null) {
            const arr = pathname.split('/workbench/app/');
            if (arr.length > 1) {
                key = arr.pop();
            }
        }

        return key;
    }
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/api/ApiBasic.ts